import React, { useEffect, useState } from 'react'
import Entete from '../components/entete'
import Backdrop from '../components/backdrop'
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { FaPlusCircle } from "react-icons/fa"
import {useNavigate} from 'react-router-dom'
import { useDispatch,useSelector } from 'react-redux';
import { RingLoader} from 'react-spinners';
import { userActions } from '../reducer/user.js'
import CreerUser from '../components/creerUser'
import VoirUser from '../components/voirUser'
import ModifierUser from '../components/modifierUser'
import SupprimerUser from '../components/supprimerUser.js'
import Avatar from 'react-avatar'
const SetComponent=({p,retour,value,supprimer,modifier})=>{
  console.log(p)
  switch (p) {
    case 'CREER':
      return(
        <div>
          <Backdrop/>
        <CreerUser retour={retour}  />
        </div>
      );
    case 'MODIFIER':
      return(
        <div>
          <Backdrop/>
        <ModifierUser retour={retour} value={value}/>
        </div>
      )
    case 'VOIR':
      return(
        <div>
          <Backdrop/>
        <VoirUser retour={retour} value={value} modifier={modifier} supprimer={supprimer}/>
        </div>
      )
    case 'SUPPRIMER':
      return(
        <div>
          <Backdrop/>
        <SupprimerUser retour={retour} value={value} />
        </div>
      )
    default:
      break;
  }
} 

export default function UserAdmin() {
  const dispatch =useDispatch()
  const [rub , setRub]=useState({nom:'',bol:false,value:null})
  useEffect(() => { 
    dispatch(userActions.liste())
  },[rub])
  
  const {isLoader,users} = useSelector((state)=>{
    return state.userReducer
   });
  const navigate=useNavigate()
  const voir=(i)=>{
    setRub({nom:'VOIR',bol:true,value:i})
  }
  const modifier=(i)=>{
    setRub({nom:'MODIFIER',bol:true,value:i})
  }
  const supprimer=(i)=>{
    setRub({nom:'SUPPRIMER',bol:true,value:i})
  }
  return (
  <div className=' w-full'>
         {rub.bol!==false&&<SetComponent p={rub.nom} retour={()=>setRub({bol:false,nom:''})} modifier={modifier} supprimer={supprimer} value={rub.value} />}
        <Entete />
    <div className='  flex w-full justify-between flex-col space-x-2 items-center '>
      <div className="flex  items-center w-full justify-between mb-2"   >
        <IoIosArrowDropleftCircle size={30} color="black" onClick={()=>navigate('/profil')}/>
        <h5 className="text-2xl font-bold ml-1 tracking-tight text-gray-900  ">Utilisateur  </h5>
          <FaPlusCircle color="gray" size={25}  onClick={()=>navigate("/userAdmin/inscriptionUser")}/>
      </div>
          
 <div  className='w-full justify-center items-center border-t '>
  {isLoader?<div className='w-full flex justify-center items-center mt-10 '> 
    <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    </div>:
    <div>
     {users.map((i,j)=>
         <div key={j} onClick={()=>voir(i)} className="flex px-2 py-5 w-full  items-center border-b hover:bg-gray-200">
            <div> 
              <Avatar name={`${i.nom} ${i.prenoms}`}  size="55" round={true} /> 
            </div>
              <div className="flex flex-col px-2 ">
               <div className="text-md font-semibold ">{i.nom} {i.prenoms} </div>
            </div>
          </div>
        )}
          
     </div>}
    </div>
    </div>
    </div>
  )
}

